export default ({amount, date}) => {
    if(!amount){
        return null;
    }
    return `${date}: ${amount} Kč`;
}